import React from 'react'
import blogData from '../../src/data/content/blog.json'

const BlogPage: React.FC = () => {
  return (
    <>
      <div className='bg-redpink text-white uppercase text-center lg:text-2xl py-2 mb-0'>
        {blogData.title}
      </div>

      <div className='bg-grisclair mb-8 overflow-x-auto'>
        <div className='max-w-7xl mx-auto px-2 lg:px-0'>
          <nav className='flex space-x-6 py-4 text-sm md:text-sm'>
            {blogData.sections.map(section => (
              <a
                key={section.id}
                href={`#${section.id}`}
                className='text-anthracite whitespace-nowrap hover:text-redpink transition-colors duration-200'
              >
                {section.title}
              </a>
            ))}
          </nav>
        </div>
      </div>

      <article className='mx-auto max-w-7xl px-2 lg:px-0'>
        <div className='space-y-8'>
          {blogData.sections.map(section => (
            <section key={section.id} id={section.id} className='scroll-mt-20'>
              <h2 className='text-lg md:text-xl lg:text-2xl font-semibold text-redpink mb-4 md:mb-6'>
                {section.title}
              </h2>
              <div className='bg-grisclair p-4 md:p-6 rounded-lg'>
                {section.content.map((item, index) => (
                  <React.Fragment key={index}>
                    {index === 0 ? (
                      <p className='font-medium text-anthracite mb-3'>{item}</p>
                    ) : (
                      <p className='text-gray-600 ml-4 mb-2'>{item}</p>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </section>
          ))}
        </div>

        <footer className='mt-12 pt-8 border-t border-gray-200 mb-8'>
          <div className='text-gray-600 mb-4'>
            {blogData.footer.contact.text}{' '}
            <a
              href={blogData.footer.contact.link.url}
              className='text-redpink hover:text-redpinkDark transition-colors duration-200'
            >
              {blogData.footer.contact.link.text}
            </a>
          </div>
        </footer>
      </article>
    </>
  )
}
export default BlogPage
